import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Cell.css';
import * as groupStyles from '../CellGroup/CellGroup.css';

export interface ICellProps {
  image?: React.ReactNode;
  children: React.ReactNode;
  accessory?: React.ReactNode;
  href?: string;
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const Cell: React.FC<ICellProps> = ({ image, children, accessory, href = '#', onClick }) => {
  return (
    <li className={styles['container']}>
      <a href={href} onClick={onClick}>
        <div className={classNames(styles['wrapper'], groupStyles['wrapper'])}>
          {image && <div className={styles['image']}>{image}</div>}
          <div className={styles['content']}>
            <div className={styles['label']}>{children}</div>
            {accessory && <div className={styles['accessory']}>{accessory}</div>}
          </div>
        </div>
      </a>
    </li>
  );
};
